<template>
    <v-form ref="form" v-model="valid" @submit.prevent="sendOrder()">

        <input type="hidden" name="tenant" :value="tenant"/>
        <input type="hidden" name="source" :value="source"/>

            <v-row dense>
                <v-col cols="12" md="4" class="d-flex" style="flex-direction:column">
                    <v-card class="mb-1">
                        <v-card-text>

                            <section aria-label="Ange vad du vill göra">
                                <label class="subtitle-1">Ärende</label>
                                <v-radio-group v-model="$store.state.form.orderType">
                                    <v-radio
                                            v-for="opt in orderTypes"
                                            :key="opt.name"
                                            :label="opt.title"
                                            :value="opt.name"
                                            :color="themeColor"
                                            name="orderType"
                                    ></v-radio>
                                </v-radio-group>
                            </section>

                            <section aria-label="Ange vilken tjänst du är intresserad av">
                                <label class="subtitle-1">Jag är intresserad av *</label>
                                <v-checkbox
                                        v-for="(opt, idx) in inspectionTypes"
                                        v-model="$store.state.form.types"
                                        :key="opt.value"
                                        :value="opt.value"
                                        :rules="[(v) => (v && v.length > 0) || 'Du måste ange vad du vill beställa']"
                                        :hide-details="idx < inspectionTypes.length - 1"
                                        name="types"
                                        class="orderType mt-0"
                                        :color="themeColor"
                                >
                                  <template v-slot:label>
                                    <v-tooltip
                                      right
                                      open-delay="600"
                                      max-width="400px"
                                      color="info"
                                      >
                                      <template v-slot:activator="{ on }">
                                        <span v-on="on">{{opt.text}}</span>
                                      </template>
                                      {{opt.description || opt.text}}
                                    </v-tooltip>
                                  </template>
                                </v-checkbox>
                            </section>
                        </v-card-text>
                    </v-card>

                  <v-card class="mb-1 flex-grow-1">
                    <v-card-text>
                            <section aria-label="Uppdragsgivarens kontaktuppgifter">
                                <label class="subtitle-1">Uppdragsgivarens kontaktuppgifter</label>

                              <v-text-field
                                v-if="showCompany"
                                id="customer-company-name"
                                label="Företagsnamn"
                                hint="Uppdragsgivarens företagsnamn (om relevant)"
                                v-model="$store.state.form.customer.companyName"
                                :rules="nameRulesRelaxed"
                                name="customerCompanyName"
                              ></v-text-field>

                                <v-row dense>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                                id="customer-first-name"
                                                label="Förnamn *"
                                                hint="Uppdragsgivarens förnamn"
                                                v-model="$store.state.form.customer.firstName"
                                                required
                                                :rules="nameRules"
                                                name="customerFirstName"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                                id="customer-last-name"
                                                label="Efternamn *"
                                                hint="Uppdragsgivarens efternamn"
                                                v-model="$store.state.form.customer.lastName"
                                                required
                                                :rules="nameRules"
                                                name="customerLastName"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <AddressFields
                                  prefix="customer"
                                  v-model="$store.state.form.customer.address"
                                  :rules="{ address: addressRulesRelaxed, postalCode: postalCodeRulesRelaxed, city: cityRulesRelaxed }"
                                />

                                <v-text-field
                                        label="Telefon *"
                                        hint="Telefon till uppdragsgivarens"
                                        v-model="$store.state.form.customer.telephone"
                                        required
                                        :rules="telephoneRules"
                                        name="customerTelephone"
                                ></v-text-field>

                                <v-text-field
                                        label="E-post *"
                                        hint="Uppdragsgivarens e-postadress"
                                        v-model="$store.state.form.customer.email"
                                        required
                                        :rules="emailRules"
                                        name="customerEmail"
                                ></v-text-field>

                              <v-text-field
                                v-if="showCustomerNumber"
                                id="customer-number"
                                label="Personnummer"
                                hint="Uppdragsgivarens personnummer (för fakturering)"
                                v-model="$store.state.form.customer.number"
                                :rules="numberRulesRelaxed"
                                name="customerNumber"
                              ></v-text-field>
                            </section>

                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4" class="d-flex" style="flex-direction:column">

                    <v-card class="mb-1" v-if="showBroker">
                        <v-card-text>
                          <section aria-label="Ange kontaktuppgifter till mäklare">
                            <label class="subtitle-1">Mäklare</label>

                            <v-text-field
                              label="Mäklarfirma"
                              hint="Namn på mäklarfirman"
                              v-model="$store.state.form.broker.companyName"
                              :rules="nameRulesRelaxed"
                              name="brokerCompanyName"
                            ></v-text-field>

                            <v-row dense>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  id="broker-first-name"
                                  label="Förnamn"
                                  hint="Mäklarens förnamn"
                                  v-model="$store.state.form.broker.firstName"
                                  :rules="nameRulesRelaxed"
                                  name="brokerFirstName"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  id="broker-last-name"
                                  label="Efternamn"
                                  hint="Mäklarens efternamn"
                                  v-model="$store.state.form.broker.lastName"
                                  :rules="nameRulesRelaxed"
                                  name="brokerLastName"
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <AddressFields
                              v-if="false"
                              v-model="$store.state.form.broker.address"
                              :rules="{ address: addressRulesRelaxed, postalCode: postalCodeRulesRelaxed, city: cityRulesRelaxed }"
                              prefix="broker"
                            />

                            <v-text-field
                              label="Telefon"
                              hint="Telefon till mäklaren"
                              v-model="$store.state.form.broker.telephone"
                              :rules="telephoneRulesRelaxed"
                              name="brokerTelephone"
                            ></v-text-field>

                            <v-text-field
                              label="E-post"
                              hint="Mäklarens e-postadress"
                              v-model="$store.state.form.broker.email"
                              :rules="emailRulesRelaxed"
                              name="brokerEmail"
                            ></v-text-field>
                          </section>

                        </v-card-text>
                    </v-card>

                  <v-card class="mb-1 flex-grow-1">
                    <v-card-text>
                            <section aria-label="Ange fakta om fastigheten">
                                <label class="subtitle-1">Objekt att besikta</label>

                                <div>
                                    <a href="#" @click="copyAddress" style="text-decoration: none;">Kopiera namn/adress från uppdragsgivaren</a>
                                </div>

                                <v-row dense>
                                  <v-col cols="12" md="6">
                                        <v-text-field
                                                label="Ägarens förnamn"
                                                v-model="$store.state.form.owner1.firstName"
                                                name="ownerFirstName"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="12" md="6">
                                        <v-text-field
                                                label="Ägarens efternamn"
                                                v-model="$store.state.form.owner1.lastName"
                                                name="ownerLastName"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                  <v-col cols="12" md="6">
                                        <v-text-field
                                                label="Ytterligare ägare förnamn"
                                                v-model="$store.state.form.owner2.firstName"
                                                name="owner2FirstName"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="12" md="6">
                                        <v-text-field
                                                label="Ytterligare ägare efternamn"
                                                v-model="$store.state.form.owner2.lastName"
                                                name="owner2LastName"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <AddressFields
                                  v-model="$store.state.form.objectAddress"
                                  prefix="object"
                                  :mandatory="['address','postalCode', 'city']"
                                  :rules="{ address: addressRules, postalCode: postalCodeRules, city: cityRules }"
                                />

                                <v-row dense>
                                  <v-col cols="12" md="6">
                                        <v-text-field
                                                label="Kommun *"
                                                v-model="$store.state.form.estateLocation"
                                                required
                                                :rules="[(v) => (v && v.length > 2) || 'Kommun är obligatoriskt']"
                                                name="estateLocation"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="12" md="6">
                                        <v-text-field
                                                label="Fastighetsbeteckning *"
                                                v-model="$store.state.form.estateNumber"
                                                required
                                                :rules="[(v) => (v && v.length > 5) || 'Fastighetsbeteckning är obligatoriskt']"
                                                hint="Xxxxx N:NNN"
                                                name="estateNumber"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </section>

                            <section>
                                <v-row dense>
                                  <AttributeColumn v-for="item in getInputs($store.state.form.orderType)" :key="item.name" :value="item">
                                    <component
                                      :is="getAttributeComponent(item)"
                                      :attribute="item"
                                      :value="$store.state.attributes[item.name]"
                                      :name="item.name"
                                      :label="item.label"
                                      :hint="item.help"
                                      @input="updateAttribute(item.name, $event)"
                                    ></component>
                                  </AttributeColumn>
                                </v-row>
                            </section>

                        </v-card-text>
                    </v-card>
                </v-col>

              <v-col cols="12" md="4" class="d-flex" style="flex-direction:column">
                <v-card class="mb-1">
                  <v-card-text>
                            <section aria-label="Ange önskat datum">

                              <v-date-picker
                                v-model="$store.state.form.preferredDate"
                                :events="events"
                                :event-color="eventColors"
                                :allowed-dates="allowedDates"
                                :color="themeColor"
                                first-day-of-week="1"
                                locale="sv-se"
                                full-width
                              ></v-date-picker>

                              <v-row dense>
                                <v-col>
                                  <v-text-field
                                    label="Önskat datum"
                                    v-model="$store.state.form.preferredDate"
                                    :rules="dateRules"
                                  ></v-text-field>
                                </v-col>
                                <v-col>
                                  <p v-if="showCalendar" class="mr-1 text-md-right"><a :href="`${tenant}/calendar?date=${$store.state.form.preferredDate}`" target="_blank">Titta i stora kalendern</a></p>
                                </v-col>
                              </v-row>

                                <p class="caption">
                                  Önskat besiktningsdatum i samband med beställning utgör inte en garanti för att vi kan utföra uppdraget den dagen.
                                  Bokningen, både datum och tid, bekräftas skriftlig av oss och framgår i uppdragsbekräftelsen.
                                </p>

                            </section>
                  </v-card-text>
                </v-card>

                <v-card class="mb-1 flex-grow-1">
                  <v-card-text>
                    <section aria-label="Lagring av personuppgifter">

                        <v-checkbox
                                name="gdpr"
                                v-model="$store.state.form.gdpr"
                                label="I enlighet med GDPR samtycker jag att mina personuppgifter sparas i samband med den här beställningen/offertförfrågan."
                                persistent-hint
                                required
                                :color="themeColor"
                                :rules="[(v) => !!v || 'Du måste godkänna lagring av personuppgifter för att kunna beställa!']"
                        ></v-checkbox>

                        <div v-if="!!legalLink" class="pl-8"><a :href="legalLink" target="_blank" style="text-decoration: none;">Läs om hur vi behandlar personuppgifter här.</a></div>
                    </section>

                  </v-card-text>

                  <v-card-actions>
                      <v-btn type="submit" :loading="sent" :disabled="sent" aria-label="Skicka beställningen" large block dark :color="buttonColor" v-text="buttonText"></v-btn>
                  </v-card-actions>
                </v-card>

                </v-col>
            </v-row>

            <div class="caption pl-1">
              *) Obligatorisk information
            </div>
    </v-form>

</template>

<script>
/* eslint-disable no-console, no-unused-vars */
import moment from 'moment'
import AddressFields from './AddressFields'
import AttributeColumn from '@/components/AttributeColumn.vue'
import ShortTextAttribute from '@/components/ShortTextAttribute.vue'
import LongTextAttribute from '@/components/LongTextAttribute.vue'
import NumericAttribute from '@/components/NumericAttribute.vue'

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,7}$/

export default {
  name: 'OrderForm',
  components: { AttributeColumn, AddressFields },
  props: {
    tenant: {
      type: String,
      required: true
    },
    organization: {
      type: Object,
      required: true
    },
    source: {
      type: String,
      required: true
    }
  },
  data: () => ({
    valid: false,
    sent: false,

    nameRules: [
      (v) => !!v || 'Namn är obligatoriskt',
      (v) => (v && v.length >= 2) || 'Namn måste vara minst två tecken'
    ],

    twoFiftyFiveRules: [
      (v) => (!v || v.length < 256) || 'Du kan ange max 255 tecken i detta fält'
    ],

    telephoneRules: [
      (v) => !!v || 'Telefon är obligatoriskt',
      (v) => (v && v.length > 7) || 'Du måste ange ett giltigt telefonnummer',
      (v) => (v && v.length <= 32) || 'Telefon får max vara 32 tecken',
      (v) => /^[0-9+\-()\s]+$/.test(v) || 'Du måste ange ett giltigt telefonnummer',
    ],
    emailRules: [
      (v) => !!v || 'E-post är obligatoriskt',
      (v) => emailRegex.test(v) || 'Du måste ange en giltig e-postadress',
      (v) => (v && v.length <= 80) || 'E-postadressen får max vara 80 tecken',
    ],

    addressRules: [
      (v) => !!v || 'Adress är obligatoriskt',
      (v) => (v && v.length >= 2) || 'Adressen måste vara minst två tecken',
      (v) => (v && v.length <= 80) || 'Adressen får max vara 80 tecken',
    ],

    postalCodeRules: [
      (v) => !!v || 'Postnr är obligatoriskt',
      (v) => (v && v.length >= 5) || 'Postnr måste vara minst fem tecken',
      (v) => (v && v.length <= 10) || 'Postnr får max vara 10 tecken',
    ],

    cityRules: [
      (v) => !!v || 'Ort är obligatoriskt',
      (v) => (v && v.length >= 2) || 'Ort måste vara minst två tecken',
      (v) => (v && v.length <= 80) || 'Orten får max vara 80 tecken',
    ],

    nameRulesRelaxed: [
      (v) => (!v || v.length >= 2) || 'Namnet måste vara minst två tecken',
      (v) => (!v || v.length <= 80) || 'Namnet får max vara 80 tecken',
    ],

    telephoneRulesRelaxed: [
      (v) => (!v || v.length > 7) || 'Du måste ange ett giltigt telefonnummer',
      (v) => (!v || v.length <= 32) || 'Telefon får max vara 32 tecken',
      (v) => (!v || /^[0-9+\-()\s]+$/.test(v)) || 'Du måste ange ett giltigt telefonnummer'
    ],
    emailRulesRelaxed: [
        (v) => (!v || emailRegex.test(v)) || 'Du måste ange en giltig e-postadress',
      (v) => (!v || v.length <= 80) || 'E-postadressen får max vara 80 tecken',
    ],

    addressRulesRelaxed: [
      (v) => (!v || v.length >= 2) || 'Adressen måste vara minst två tecken',
      (v) => (!v || v.length <= 80) || 'Adressen får max vara 80 tecken',
    ],

    postalCodeRulesRelaxed: [
      (v) => (!v || v.length >= 5) || 'Postnr måste vara minst fem tecken',
      (v) => (!v || v.length <= 10) || 'Postnr får max vara 10 tecken',
    ],

    cityRulesRelaxed: [
      (v) => (!v || v.length >= 2) || 'Orten måste vara minst två tecken',
      (v) => (!v || v.length <= 80) || 'Orten får max vara 80 tecken',
    ],

    numberRulesRelaxed: [
      (v) => (!v || v.length >= 10) || 'Personnummer måste vara minst 10 tecken',
      (v) => (!v || v.length <= 13) || 'Personnummer får max vara 13 tecken',
    ],

    yearRules: [
      (v) => (!v || /^[0-9]{4}$/.test(v)) || 'Du måste ange ett giltigt årtal'
    ],

    numericRules: [
      (v) => (!v || /^[0-9]{1,3}$/.test(v)) || 'Du måste ange ett heltal (1-999)'
    ],

    buttonText: 'Skicka',
    formState: null,
  }),
  computed: {
    themeColor () {
      return this.$store.getters.setting('order.theme.color') || null
    },
    buttonColor () {
      return this.formState || this.themeColor || 'primary'
    },
    orderTypes () {
      return this.$store.state.orderTypes
    },
    inspectionTypes () {
      return this.$store.state.inspectionTypes
    },
    bookedDates () {
      return this.$store.getters.calendarEvents.map(event => {
        const dates = []
        const end = (event.end ? moment(event.end) : moment()).endOf('days')
        let date = (event.start ? moment(event.start) : moment()).startOf('days')
        while(date.isBefore(end)) {
          dates.push(date.format('YYYY-MM-DD'))
          date.add(1, 'days')
        }
        return dates
      }).flat()
    },
    showCalendar () {
      return this.$store.getters.setting('order.calendar.enabled') === 'true'
    },
    showCalendarEvents () {
      return this.$store.getters.setting('order.calendar.events') === 'true'
    },
    saturday () {
      return this.$store.getters.setting('order.calendar.saturday') === 'true'
    },
    sunday () {
      return this.$store.getters.setting('order.calendar.sunday') === 'true'
    },
    dateRules () {
      return [v => this.allowedDates(v) || 'Datumet är inte bokningsbart']
    },
    showCompany () {
      return this.$store.getters.setting('order.company.enabled') === 'true'
    },
    showCustomerNumber () {
      return this.$store.getters.setting('order.personnr.enabled') === 'true'
    },
    showBroker () {
      return this.$store.getters.setting('order.broker.enabled') === 'true'
    },
    legalLink () {
      const text = this.$store.getters.setting('order.legal.text')
      if (text) {
        if (text.startsWith('http:') || text.startsWith('https:')) {
          return text.trim()
        } else {
          return `${this.tenant}/legal`
        }
      }
      return null
    },
  },
  methods: {
    getInputs (orderType) {
      if (orderType) {
        const list = this.$store.getters.orderForms[orderType]
        if (list) {
          return list
        }
      }
      return []
    },
    getAttributeComponent (item) {
      if (item.dataType === 'INTEGER') {
        return NumericAttribute
      } else {
        if (item.maxLength > 100) {
          return LongTextAttribute
        }
      }
      return ShortTextAttribute
    },
    updateAttribute (name, value) {
      this.$store.commit('setAttribute', { name, value })
    },
    events (date) {
      return this.showCalendarEvents ? this.bookedDates.includes(date) : false
    },
    eventColors (date) {
      return 'red'
    },
    allowedDates (date) {
      if (moment(date).isoWeekday() === 6 && ! this.saturday) {
        return false
      }
      if (moment(date).isoWeekday() === 7 && ! this.sunday) {
        return false
      }
      return true
    },
    copyAddress () {
      this.$store.dispatch('setOwnerInfo', this.$store.getters.customer)
    },
    sendOrder () {
      const form = this.$refs.form
      this.formState = null
      if (form.validate() && ! this.sent) {
        this.sent = true
        const data = { ...this.$store.state.form }
        const attributes = this.getInputs(this.$store.state.form.orderType)
        const values = []
        for (let i = 0; i < attributes.length; i++) {
          const attr = attributes[i]
          const value = this.$store.state.attributes[attr.name]
          if (value) {
            values.push({ scope: attr.scope, name: attr.name, value: value})
          }
        }
        data.attributes = values

        this.$store.dispatch('saveOrder', data)
          .then(result => {
            this.buttonText = 'Skickar beställning...!'
            this.formState = 'success'
            setTimeout(() => this.doAfterSuccess(result), 2000)
          })
          .catch((err) => {
            console.log(err)
            this.buttonText = 'Beställningen kunde inte skickas!'
            this.formState = 'error'
            this.sent = false
          })
      }
    },
    doAfterSuccess (result) {
      this.$store.dispatch('resetForm')
      this.$emit('success', result)
    }
  },
  mounted () {
    this.formState = null
  }
}
</script>

<style scoped>
  .orderType .error--text {
    margin-top: 14px;
  }
</style>
